import { createUseStyles } from 'react-jss';

export const addEditProduct = createUseStyles({
  container: {

  },
});
